import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

/**
 * Checks the pin code of the kiosk secret menu. Resolves to `true` when the
 * pin code is correct.
 */
const useKioskPinCodeVerify = () => {
  const branchId = useBranchId();

  const mutation = useMutation({
    mutationFn: async (pinCode: string): Promise<boolean> => {
      const data = await post2(
        `/internal/secure/pos/v1/kiosk-settings/pincode-check/${branchId}`,
        { pin_code: pinCode }
      );
      // The endpoint answers with a plain `true` / `false`
      return data === true || data === "true";
    },
  });

  return mutation;
};

export default useKioskPinCodeVerify;
